import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { getTenantConfig } from './theme/tenantConfigs';

const UnauthorizedPage: React.FC = () => {
  const { logout, user } = useAuth0();
  const tenant = getTenantConfig();

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: "8vh",
        width: '100%',
        height: 'calc(100dvh - 15vh)',
        overflow: 'hidden',
        mt: 0,
        mb: 0,
        p: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: tenant.gradient || '#f5f5f5',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          width: 'calc(100% - 40px)',
          maxWidth: '600px',
          textAlign: 'center',
          borderRadius: 2,
        }}
      >
        <Typography variant="h4" gutterBottom>
          Access Restricted
        </Typography>
        <Typography variant="body1" paragraph>
          Your account doesn't have the necessary permissions to access this area.
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Please contact your administrator if you believe this is an error.
        </Typography>
        <Button 
          variant="contained" 
          onClick={handleLogout}
          sx={{ 
            mt: 2,
            background: tenant.gradient || 'primary',
            '&:hover': {
              opacity: 0.9,
            }
          }}
        >
          Sign Out
        </Button>
      </Paper>
    </Box>
  );
};

export default UnauthorizedPage;